import React from 'react';
import { connect } from 'react-redux';
import { Grid, Paper, Typography, withStyles, Button } from '@material-ui/core';
import GetAppIcon from '@material-ui/icons/GetApp';
import { BackButton } from '../sc-utilities';
import { icon } from '../sc-download-page/Remote';
import { styles } from './index';

const RemoteManual = (props) => {
    const { classes, translations } = props;

    return (
        <Paper className={classes.root}>
            <div className={classes.customToolbar}>
                <div className={classes.tableTitle}>
                    {BackButton(translations, classes.customTooltip)}
                    <Typography className={classes.typography}>
                        {translations['user_manuals'] || 'User Manuals'}
                    </Typography>
                </div>
            </div>

            <Grid container direction="row" className={classes.grid}>
                <Grid item ms={12} lg={6}>
                    <h2>
                        {icon} Remote{' '}
                        {classes.latestVersionSpan && (
                            <span className={classes.latestVersionSpan}>
                                - {translations['latest_version'] || 'Latest Version'}
                            </span>
                        )}
                    </h2>
                    <p>
                        {translations['remote_download_page'] ||
                            'Tool for remote erasure of data on Windows devices by system administrators.'}
                    </p>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <a
                        href="https://securaze.com/en/help/remote"
                        download
                        target={'_blank'}
                        rel="noopener noreferrer"
                        className={classes.link}
                    >
                        <Button color={'primary'} variant={'contained'} className={classes.history}>
                            <GetAppIcon /> {translations['remote'] || 'Remote'}
                            {'.pdf'}
                        </Button>
                    </a>
                </Grid>
            </Grid>
        </Paper>
    );
};

const mapStateToProps = (state) => {
    return {
        translations: state?.translate?.translations?.activeTranslations || {},
    };
};

export default connect(mapStateToProps, null)(withStyles(styles, { withTheme: true })(RemoteManual));
